module.exports = __webpack_public_path__ + "static-portal/img/bg-1.fw.c574326.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-1.fw.png
// module id = mzT+
// module chunks = 4